// To be able to request the Staging API from Local to increase development efficiency
export const STAGING_API_ENDPOINT = 'https://staging.up-sider.com/api/bank'
